import MemberIcon from '@repo/ui/components/Icon/MemberIcon';

import { DisabledWrapper } from './styles';

const FreePlanMemberSelect: React.FC = () => {
  return (
    <DisabledWrapper>
      <MemberIcon height="15px" />
      Up to 5 Members
    </DisabledWrapper>
  );
};

export default FreePlanMemberSelect;
